<template>
  <div class="news-teaser" ref="NewsItem">

      <router-link :to="{ name: 'newsFull', params: { slug : field_path }}">
      <div class="date" ref="NewsDate">{{ datestamp(date) }}</div>
      <div class="news-teaser-content">
        <div class="news-teaser-image" ref="NewsImage">
          <img class="image" :src="image.url" v-if="image.url"/>
        </div>
        <div class="title" ref="NewsTitle">{{ title }}</div>
        <div class="summary" ref="NewsSummary">{{ summary }}</div>
      </div>
      <div class="cta-read" ref="NewsCta">Leggi</div>
    </router-link>
  </div>
</template>

<script>
  import moment from 'moment';
  import {TimelineMax} from 'gsap'
  import ScrollMagic from 'scrollmagic'
  import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap'
  import slug from 'slug'

  export default {
    name: 'NewsTeaser',
    props: ['news'],
    data() {
      return {
        image: [],
        title: [],
        date: [],
        summary: [],
        uuid : '',
        field_path : [],
        controller: new ScrollMagic.Controller(),
      }
    },
    created() {
      // Title.
      if (this.news.hasOwnProperty('title')) {
        this.title = this.news.title;
      }
      // Summary.
      if (this.news.body.hasOwnProperty('summary')) {
        this.summary = this.news.body.summary;
      }
      // Date.
      if (this.news.hasOwnProperty('data')) {
        this.date = this.news.data;
      }
      // Id.
      if (this.news.hasOwnProperty('id')) {
        this.uuid = this.news.id;
      }
      // Path.
      if (this.news.hasOwnProperty('field_path')) {
        var temp = this.news.field_path;
        this.field_path = temp.replace('/news/', '');
      }
      // Get Featured image attributes.
      this.image.url = process.env.VUE_APP_HOST_URL + this.news.featured_image.url;
      },
    mounted() {
      this.animations();
    },
    methods: {
      datestamp: function (date) {
        return moment(date).locale('it').format('LL');
      },
      slugText(text) {
        return slug(text, {lower: true});
      },
      animations() {
        const {NewsItem} = this.$refs
        const {NewsDate} = this.$refs
        const {NewsImage} = this.$refs
        const {NewsTitle} = this.$refs
        const {NewsSummary} = this.$refs
        const {NewsCta} = this.$refs

        const timeline = new TimelineMax({paused: true})
        timeline.from(NewsItem, .35, {opacity: 0, ease: Power4.easeOut}, '-=0')
                .from(NewsDate, .35, {opacity: 0, y: -20, ease: Power4.easeOut}, '-=0.35')
                .from(NewsImage, 1, {opacity: 0, y: -20, ease: Power4.easeOut}, '-=0.35')
                .from(NewsTitle, .35, {opacity: 0, y: 30, ease: Power4.easeOut}, '-=1')
                .from(NewsSummary, .35, {opacity: 0, y: 30, ease: Power4.easeOut}, '-=1')
                .from(NewsCta, .35, {opacity: 0, y: 30, ease: Power4.easeOut}, '-=0.85');

        const scene = new ScrollMagic.Scene({
          triggerElement: NewsItem,
          triggerHook: 0.75,
          offset: 0
        }).on('enter', function (event) {
          timeline.play().timeScale(1);
        }).on('leave', function (event) {
          timeline.reverse().timeScale(1.5)
        }).addTo(this.controller);
      }
    }
  }
</script>
